import { Image } from '../types/Image'
import { SImage } from '../types/api/Image'

export const imageTransformer = (image: SImage | null | undefined): Image => {
  const raw: any = image ?? {}
  return {
    id: raw.documentId ?? (raw.id != null ? String(raw.id) : ''),
    name: raw.name ?? null,
    alternativeText: raw.alternativeText ?? null,
    formats: raw.formats ?? {},
    url: raw.url ?? '',
    width: raw.width ?? 0,
    height: raw.height ?? 0,
    caption: raw.caption ?? '',
  }
}
